import type { RedoPlatformRpcClient } from "@redotech/redo-merchant-platform-rpc-client/client";
import { createRedoPlatformRpcClient } from "@redotech/redo-merchant-platform-rpc-client/client";
import { Context, createContext, ReactNode, useMemo } from "react";

export const RedoPlatformPublicRpcClientContext: Context<
  RedoPlatformRpcClient | undefined
> = createContext<RedoPlatformRpcClient | undefined>(undefined);

RedoPlatformPublicRpcClientContext.displayName =
  "RedoPlatformPublicRpcClientContext";

export const RedoPlatformAuthRpcClientContext: Context<
  RedoPlatformRpcClient | undefined
> = createContext<RedoPlatformRpcClient | undefined>(undefined);

RedoPlatformAuthRpcClientContext.displayName =
  "RedoPlatformAuthRpcClientContext";

export interface RedoPlatformRpcClientProviderProps {
  children: ReactNode | ReactNode[];
  baseUrl: string;
  authToken?: string;
}

export function RedoPlatformRpcClientProvider({
  children,
  baseUrl,
  authToken,
}: RedoPlatformRpcClientProviderProps) {
  const publicClient = useMemo(() => {
    return createRedoPlatformRpcClient({
      baseURL: new URL(`${baseUrl}/platform-rpc`),
    });
  }, [baseUrl]);

  const authClient = useMemo(() => {
    if (!authToken) {
      return undefined;
    }
    return createRedoPlatformRpcClient({
      baseURL: new URL(`${baseUrl}/platform-rpc`),
      headers: { Authorization: authToken },
    });
  }, [baseUrl, authToken]);

  return (
    <RedoPlatformPublicRpcClientContext.Provider value={publicClient}>
      <RedoPlatformAuthRpcClientContext.Provider value={authClient}>
        {children}
      </RedoPlatformAuthRpcClientContext.Provider>
    </RedoPlatformPublicRpcClientContext.Provider>
  );
}
